var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 306,
    viewBox: "0 0 406 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M115.294 138.79C115.294 138.79 124.53 95.3379 147.774 95.3379C171.017 95.3379 183.38 163.647 126.845 171.077L115.294 138.79Z",
    style: {
      fill: "var(--skin-color)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M115.294 138.79C115.294 138.79 124.53 95.3379 147.774 95.3379C171.017 95.3379 183.38 163.647 126.845 171.077L115.294 138.79Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.42 48.4346H146.812C140.185 48.4346 134.812 53.8072 134.812 60.4346V215.765C134.812 222.392 140.185 227.765 146.813 227.765H267.42C274.047 227.765 279.42 222.392 279.42 215.765V60.4346C279.42 53.8072 274.047 48.4346 267.42 48.4346Z",
    style: {
      fill: "var(--clothes-color)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.905 59.3154H148.81V212.733H264.905V59.3154Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.51 37.6553H182.275C178.962 37.6553 176.275 40.3416 176.275 43.6553V58.502C176.275 61.8157 178.962 64.502 182.275 64.502H233.51C236.824 64.502 239.51 61.8157 239.51 58.502V43.6553C239.51 40.3416 236.824 37.6553 233.51 37.6553Z",
    fill: "#C8D5DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M227.492 128.132H202.808C201.703 128.132 200.808 129.028 200.808 130.132V132.456C200.808 133.56 201.703 134.456 202.808 134.456H227.492C228.596 134.456 229.492 133.56 229.492 132.456V130.132C229.492 129.028 228.596 128.132 227.492 128.132Z",
    fill: "#A8A8A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M244.249 140.698H202.808C201.703 140.698 200.808 141.594 200.808 142.698V145.022C200.808 146.126 201.703 147.022 202.808 147.022H244.249C245.354 147.022 246.249 146.126 246.249 145.022V142.698C246.249 141.594 245.354 140.698 244.249 140.698Z",
    fill: "#A8A8A8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M227.492 168.793H202.808C201.703 168.793 200.808 169.689 200.808 170.793V173.117C200.808 174.221 201.703 175.117 202.808 175.117H227.492C228.596 175.117 229.492 174.221 229.492 173.117V170.793C229.492 169.689 228.596 168.793 227.492 168.793Z",
    fill: "#A8A8A8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M244.249 181.369H202.808C201.703 181.369 200.808 182.265 200.808 183.369V185.693C200.808 186.797 201.703 187.693 202.808 187.693H244.249C245.354 187.693 246.249 186.797 246.249 185.693V183.369C246.249 182.265 245.354 181.369 244.249 181.369Z",
    fill: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M185.49 83.9395H167.577C165.368 83.9395 163.577 85.7303 163.577 87.9395V105.852C163.577 108.062 165.368 109.852 167.577 109.852H185.49C187.699 109.852 189.49 108.062 189.49 105.852V87.9395C189.49 85.7303 187.699 83.9395 185.49 83.9395Z",
    style: {
      fill: "var(--red-puzzle-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.49 124.367H163.577V150.28H189.49V124.367Z",
    style: {
      fill: "var(--red-puzzle-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.49 164.794H167.577C165.368 164.794 163.577 166.585 163.577 168.794V186.707C163.577 188.917 165.368 190.707 167.577 190.707H185.49C187.699 190.707 189.49 188.917 189.49 186.707V168.794C189.49 166.585 187.699 164.794 185.49 164.794Z",
    style: {
      fill: "var(--red-puzzle-color)"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M172.296 96.8606L175.351 101.316L181.685 93.1152",
    stroke: "white",
    strokeWidth: 4.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M172.296 137.227L175.351 141.683L181.685 133.471",
    stroke: "white",
    strokeWidth: 4.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M172.296 177.888L175.351 182.344L181.685 174.143",
    stroke: "white",
    strokeWidth: 4.06,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.48 133.715C277.48 133.715 262.885 120.632 241.275 129.655C224.355 136.76 232.364 145.113 241.458 144.758C250.552 144.403 265.818 138.201 264.752 153.304C263.788 166.611 247.284 147.478 237.824 148.229C228.364 148.981 229.45 159.729 241.103 165.627C252.755 171.524 269.117 184.292 281.855 174.264C294.593 164.236 290.949 146.423 277.48 133.715Z",
    style: {
      fill: "var(--skin-color)"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M273.664 177.999L324.769 261.199L366.466 225.603L293.132 153.518L273.664 177.999Z",
    fill: "#FBECE7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.503 122.601C133.503 122.601 151.449 104.26 159.193 105.884C165.588 107.234 165.598 119.951 151.662 130.548C148.833 132.675 146.494 135.386 144.804 138.496C143.114 141.606 142.112 145.043 141.867 148.574C141.471 154.492 139.512 161.536 133.503 166.844C120.867 178.009 111.488 168.286 112.706 153.183C113.924 138.079 114.746 133.613 133.503 122.601Z",
    style: {
      fill: "var(--skin-color)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M140.486 164.449L133.736 257.779L78.4189 247.172L106.24 154.066L140.486 164.449Z",
    fill: "#FBECE7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M227.492 86.7915H202.808C201.703 86.7915 200.808 87.6869 200.808 88.7915V91.115C200.808 92.2195 201.703 93.115 202.808 93.115H227.492C228.596 93.115 229.492 92.2195 229.492 91.115V88.7915C229.492 87.6869 228.596 86.7915 227.492 86.7915Z",
    fill: "#A8A8A8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M244.249 99.3574H202.808C201.703 99.3574 200.808 100.253 200.808 101.357V103.681C200.808 104.785 201.703 105.681 202.808 105.681H244.249C245.354 105.681 246.249 104.785 246.249 103.681V101.357C246.249 100.253 245.354 99.3574 244.249 99.3574Z",
    fill: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M112.147 253.637L124.135 159.496L140.486 164.449L133.737 257.779L112.147 253.637Z",
    style: {
      fill: "var(--red-puzzle-color)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M273.664 178L282.677 166.662L343.212 245.457L324.769 261.199L273.664 178Z",
    style: {
      fill: "var(--red-puzzle-color)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInventory);
export default __webpack_public_path__ + "static/media/no-inventory.dd692205aca1afdf162a9a3d0bb8cba9.svg";
export { ForwardRef as ReactComponent };